/* Udyan B2B — custom select.
   Progressive enhancement over a real <select>: without JavaScript the native
   control still renders, posts and validates. With it, the native select is
   visually hidden (clipped, not display:none, so constraint validation can
   still focus it) and a listbox matching the design takes its place. */
(function () {
  var CHEVRON =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 9l7 7 7-7"/></svg>';
  var TICK =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="3" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12l6 6L20 6"/></svg>';

  function enhance(select) {
    if (select.dataset.b2bSelectReady) return;
    select.dataset.b2bSelectReady = '1';

    var wrap = select.closest('.b2b-form__select-wrap');
    if (!wrap) return;
    wrap.classList.add('b2b-select', 'is-enhanced');
    select.classList.add('b2b-select__native');

    var id = select.id || ('b2b-sel-' + Math.random().toString(36).slice(2));
    var labelEl = wrap.closest('.b2b-form__field') && wrap.closest('.b2b-form__field').querySelector('label');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'b2b-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.id = id + '-trigger';
    if (labelEl) trigger.setAttribute('aria-labelledby', (labelEl.id = labelEl.id || id + '-label') + ' ' + trigger.id);

    var value = document.createElement('span');
    value.className = 'b2b-select__value';
    var disc = document.createElement('span');
    disc.className = 'b2b-select__disc';
    disc.innerHTML = CHEVRON;
    trigger.appendChild(value);
    trigger.appendChild(disc);

    var menu = document.createElement('ul');
    menu.className = 'b2b-select__menu';
    menu.setAttribute('role', 'listbox');
    menu.id = id + '-menu';
    menu.hidden = true;
    trigger.setAttribute('aria-controls', menu.id);

    var options = [];
    Array.prototype.forEach.call(select.options, function (opt, i) {
      if (opt.disabled && opt.value === '') return; // the placeholder
      var li = document.createElement('li');
      li.className = 'b2b-select__option';
      li.setAttribute('role', 'option');
      li.id = id + '-opt-' + i;
      li.dataset.value = opt.value;
      li.setAttribute('aria-selected', 'false');
      li.innerHTML = '<span>' + opt.text + '</span>';
      menu.appendChild(li);
      options.push(li);
    });

    wrap.appendChild(trigger);
    wrap.appendChild(menu);

    var placeholder = (select.options[0] && select.options[0].disabled) ? select.options[0].text : '';
    var active = -1;

    function paint() {
      var v = select.value;
      value.textContent = v ? select.options[select.selectedIndex].text : placeholder;
      wrap.classList.toggle('is-placeholder', !v);
      options.forEach(function (li) {
        var on = li.dataset.value === v && v !== '';
        li.setAttribute('aria-selected', on ? 'true' : 'false');
        li.innerHTML = '<span>' + li.textContent.trim() + '</span>' + (on ? TICK : '');
      });
    }

    function open() {
      if (!menu.hidden) return;
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      active = options.findIndex(function (li) { return li.getAttribute('aria-selected') === 'true'; });
      if (active < 0) active = 0;
      setActive(active);
      document.addEventListener('mousedown', onOutside, true);
    }

    function close(refocus) {
      if (menu.hidden) return;
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.removeAttribute('aria-activedescendant');
      wrap.classList.remove('is-open');
      options.forEach(function (li) { li.classList.remove('is-active'); });
      document.removeEventListener('mousedown', onOutside, true);
      if (refocus) trigger.focus();
    }

    function onOutside(e) { if (!wrap.contains(e.target)) close(false); }

    function setActive(i) {
      if (!options.length) return;
      active = (i + options.length) % options.length;
      options.forEach(function (li, n) { li.classList.toggle('is-active', n === active); });
      trigger.setAttribute('aria-activedescendant', options[active].id);
      var li = options[active];
      if (li.offsetTop < menu.scrollTop) menu.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > menu.scrollTop + menu.clientHeight)
        menu.scrollTop = li.offsetTop + li.offsetHeight - menu.clientHeight;
    }

    function pick(i) {
      select.value = options[i].dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      paint();
      close(true);
    }

    trigger.addEventListener('click', function () { menu.hidden ? open() : close(true); });

    trigger.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown': case 'ArrowUp':
          e.preventDefault();
          if (menu.hidden) open(); else setActive(active + (e.key === 'ArrowDown' ? 1 : -1));
          break;
        case 'Home': if (!menu.hidden) { e.preventDefault(); setActive(0); } break;
        case 'End':  if (!menu.hidden) { e.preventDefault(); setActive(options.length - 1); } break;
        case 'Enter': case ' ':
          e.preventDefault();
          if (menu.hidden) open(); else pick(active);
          break;
        case 'Escape': close(true); break;
        case 'Tab': close(false); break;
        default:
          // type-ahead, which matters for the country list
          if (e.key.length === 1) {
            var q = e.key.toLowerCase();
            var from = menu.hidden ? 0 : active + 1;
            for (var n = 0; n < options.length; n++) {
              var idx = (from + n) % options.length;
              if (options[idx].textContent.trim().toLowerCase().indexOf(q) === 0) {
                if (menu.hidden) open();
                setActive(idx);
                break;
              }
            }
          }
      }
    });

    menu.addEventListener('click', function (e) {
      var li = e.target.closest('.b2b-select__option');
      if (li) pick(options.indexOf(li));
    });

    select.addEventListener('change', paint);
    // a failed submit focuses the native control; surface that on the trigger
    select.addEventListener('invalid', function () { wrap.classList.add('is-invalid'); trigger.focus(); });
    paint();
  }

  function init() {
    document.querySelectorAll('.b2b-form__select-wrap select').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
